import { MSFilterSliderSkeleton } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/filter/skeletons/slider";
import { SHStack } from "@components/design-systems";
import {
  MSFilterTrackRecordSkeleton
} from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/filter/skeletons/track-record";

type MSFilterCombinedSliderSkeletonProps = {
  includeDropdown?: boolean;
};

export const MSFilterCombinedSliderSkeleton = ({
  includeDropdown = false,
}: MSFilterCombinedSliderSkeletonProps) => {
  return (
    <SHStack gap={1.5}>
      {includeDropdown && (
        <MSFilterTrackRecordSkeleton showIcon={false} />
      )}
      {Array.from({ length: 4 }).map((_, i) => (
        <MSFilterSliderSkeleton key={i} />
      ))}
    </SHStack>
  );
};
